import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import classNames from 'classnames';
import { groundsDispatch } from './utils';
import styles from './index.css';
import { BASE_PATH } from '@src/mobile/constants';

const Link = ({ children, to, type = 'web', target, className = '', style = {} }) => {
    if (window.grounds && window.grounds.dispatch) {
        const handleSpanClick = () => {
            groundsDispatch({ to, type });
        };

        return (
            <span onClick={handleSpanClick} className={classNames(styles.span, className)} style={style}>
                {children}
            </span>
        );
    } else {
        return (
            <a href={to} {...(target ? { target } : {})} className={classNames(styles.a, className)} style={style}>
                {children}
            </a>
        );
    }
};

Link.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
    to: PropTypes.string,
    type: PropTypes.string,
    target: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    needLinkAnalyze: PropTypes.bool,
};

export const linkBase = `${window.location.origin}${BASE_PATH}`;

export default errorBoundary(Link);
